module.exports = __webpack_public_path__ + "static/img/pic71.3ac33ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic71.png
// module id = hD0x
// module chunks = 1